import { FC, useMemo } from "react";

import { isStringWithNumber } from "../../../../../utils";
import { useGetDebtStateQuery } from "../../../../../api/debt";
import { useGetScheduleQuery } from "../../../../../api/schedule";
import { MainPagePaymentScheduleAllPaid } from "./MainPagePaymentScheduleAllPaid";
import { MainPagePaymentScheduleNearest } from "./MainPagePaymentScheduleNearest";
import { MainPagePaymentScheduleOverdue } from "./MainPagePaymentScheduleOverdue";

export const MainPagePaymentScheduleContent: FC = () => {
  const { data: schedule } = useGetScheduleQuery();
  const { data: debt } = useGetDebtStateQuery();

  const { nearestPayment, isAllPaymentsPaid } = useMemo(() => {
    const sortedSchedule = Array.isArray(schedule?.periods)
      ? schedule.periods.sort((a, b) => (a.idx ?? 0) - (b.idx ?? 0))
      : [];

    let isAllPaymentsPaid = false;
    const nearestPayment = sortedSchedule.find(payment => payment.status === "PLANNED");

    if (!nearestPayment) {
      isAllPaymentsPaid = sortedSchedule.length > 0 && sortedSchedule.every(p => p.status === "PAID");
    }

    return {
      nearestPayment,
      isAllPaymentsPaid,
    };
  }, [schedule]);

  const overdue = isStringWithNumber(debt?.overdue?.total) && Number(debt?.overdue?.total) > 0;

  if (overdue) {
    return <MainPagePaymentScheduleOverdue overdue={debt!.overdue!.total!} />;
  }

  if (isAllPaymentsPaid) {
    return <MainPagePaymentScheduleAllPaid />;
  }

  return <MainPagePaymentScheduleNearest nearestPayment={nearestPayment} />;
};
